export function formatPercentage(
  decimal: number | undefined,
): string | undefined {
  if (typeof decimal !== 'number' || isNaN(decimal)) {
    return undefined;
  }
  return `${Math.floor(decimal * 100)}%`;
}
